/*
===========================================================
BM PRODUCT OUT OF STOCK ENGINE
Version : 1.0
Author  : BM

PART 1
===========================================================
*/

(function () {

  "use strict";

  const BM = {

    selectors: [

      ".m-collection-products",
      ".m-product-grid",
      ".product-grid",
      ".grid",
      ".swiper-wrapper",
      ".flickity-slider"

    ],


    soldOutSelectors: [

      ".m-product-tag--soldout",
      ".m-product-tag--sold-out",
      ".badge--sold-out",
      ".sold-out"

    ],

    observer: null

  };

function isSoldOut(card) {

  const productCard = card.querySelector(".m-product-card");

  if (!productCard) return false;

  return productCard.dataset.variantAvailable === "false";

}
  
    function sortContainer(container) {

    if (!container) return;
if (container.dataset.bmSorted === "true") return;
    const cards = [...container.children].filter(el =>
  el.classList.contains("m-product-item")
);

    if (!cards.length) return;

    const inStock = [];
    const outOfStock = [];

    cards.forEach(card => {

      if (isSoldOut(card)) {
        outOfStock.push(card);
      } else {
        inStock.push(card);
      }

    });

    if (!outOfStock.length) return;

    const sortedCards = [...inStock, ...outOfStock];

// Already sorted hai to kuch mat karo
let changed = false;

for (let i = 0; i < sortedCards.length; i++) {
  if (container.children[i] !== sortedCards[i]) {
    changed = true;
    break;
  }
}

if (!changed) {

  container.dataset.bmSorted = "true";

  container.classList.remove("bm-loading");
  container.classList.add("bm-ready");

  return;
}

// Sirf jo product galat position me hai usko move karo
for (let i = 0; i < sortedCards.length; i++) {
  if (container.children[i] !== sortedCards[i]) {
    container.insertBefore(sortedCards[i], container.children[i]);
  }
}

container.dataset.bmSorted = "true";
container.classList.remove("bm-loading");
container.classList.add("bm-ready");

  }

function observeContainer(container) {

  if (!container || container.bmObserver) return;

  const observer = new MutationObserver(() => {

    if (container.dataset.bmSorting === "true") return;

    requestAnimationFrame(() => {

    delete container.dataset.bmSorted;

    sortContainer(container);

});

  });

  observer.observe(container, {
    childList: true
  });

  container.bmObserver = observer;

}



  function runEngine() {

  if (document.hidden) return;

  requestAnimationFrame(() => {

    BM.selectors.forEach(selector => {

      document.querySelectorAll(selector).forEach(container => {

          observeContainer(container);
    delete container.dataset.bmSorted;
sortContainer(container);

      });

    });

  });

}

  function debounce(fn, delay = 100) {

    let timer;

    return function () {

      clearTimeout(timer);

      timer = setTimeout(fn, delay);

    };

  }

  const refresh = debounce(runEngine, 120);

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runEngine);
} else {
  runEngine();
}

  ///document.addEventListener("shopify:section:load", runEngine);

  ///document.addEventListener("shopify:section:reorder", runEngine);

 /// document.addEventListener("shopify:section:select", runEngine);

  if ("MutationObserver" in window) {

   // BM.observer = new MutationObserver(refresh);

 //   BM.observer.observe(document.body, {

    //  childList: true,

   //   subtree: true

   // });

  }

  /// AJAX support

document.addEventListener("ajaxProduct:added", () => {

  document.querySelectorAll(".m-collection-products").forEach(el => {
    delete el.dataset.bmSorted;
  });

  refresh();

});

document.addEventListener("collection:updated", () => {

  document.querySelectorAll(".m-collection-products").forEach(el => {
    delete el.dataset.bmSorted;
  });

  refresh();

});

document.addEventListener("facet:updated", () => {

  document.querySelectorAll(".m-collection-products").forEach(el => {
    delete el.dataset.bmSorted;
  });

  refresh();

});
  
setTimeout(() => {

  document.querySelectorAll(".m-collection-products").forEach(el => {

    
    el.classList.add("bm-ready");

  });

},2000);

})();


(function () {
  "use strict";

  /*
   * BM COLLECTION - ONE TIME RELOAD
   * Only collection pages
   * Maximum 1 reload per collection URL per browser session
   */

  if (!document.body.classList.contains("template-collection")) {
    return;
  }

  const STORAGE_KEY =
    "__bm_collection_reload_" + window.location.pathname;

  // Already reloaded once for this collection
  if (sessionStorage.getItem(STORAGE_KEY) === "1") {
    return;
  }

  let reloadScheduled = false;

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  function reloadCollectionOnce() {

    if (reloadScheduled) return;

    // Mark BEFORE reload so it cannot create a loop
    sessionStorage.setItem(STORAGE_KEY, "1");

    reloadScheduled = true;

    setTimeout(function () {
      window.location.reload();
    }, 50);
  }

  history.pushState = function () {

    const result = originalPushState.apply(this, arguments);

    reloadCollectionOnce();

    return result;
  };

  history.replaceState = function () {

    const result = originalReplaceState.apply(this, arguments);

    reloadCollectionOnce();

    return result;
  };

})();